import React, { Component } from 'react';
import { connect } from "react-redux";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, PieChart, Pie, Legend, Label,} from "recharts";

import axios from "axios";
import moment from "moment";

import { VCCheckin, VCCheckout } from '../../../../Common/Buttons/Icons';

import EmptyState from '../../../../Common/EmptyState.jsx';
import { LoadingIcon } from '../../../../Common/Loading_Icon';
import MediaRating from '../../../../Common/Blocks/MediaRating';
import ArticlesBreakdown from '../../../../Common/Blocks/ArticlesBreakdown';
import { constants } from '../../../../../Helpers/Constants';
import {GridContainer, GridItem} from '../../../../Common/DesignSystem/Grid';
import { P2, P3, Heading5, CaptionMedium, P3Bold, P4, P2Bold, Heading3 } from '../../../../Common/DesignSystem/Text';
import colours from '../../../../Common/DesignSystem/Colours';
import Icon from '../../../../Common/DesignSystem/Icons/Icon';
import { Trans } from 'react-i18next';
import { ActivityCard, ActivityCardItem } from '../../../../Common/DesignSystem/ActivityCard';
import { debounce } from '@material-ui/core';

class ProfileOverviewTab extends Component {

    constructor(props) {
        super(props);

        this.generateActivity = this.generateActivity.bind(this);
        this.setupBookingsBreakdown = this.setupBookingsBreakdown.bind(this);
        this.reloadReports = this.reloadReports.bind(this);
        this.getLastBooking = this.getLastBooking.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.state = {
            bookings_breakdown: this.setupBookingsBreakdown(this.props.profile_details.booking_breakdown, 12),
            articles_last_period: 0,
            articles_this_period: 0,
            num_bookings_last_period: 0,
            num_bookings_this_period: 0,
            custom_loaded: false,
            loading: false,
            windowWidth: window.innerWidth,
            rerenderChart: 0
        };       
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
        if ("reports" in this.props.profile_details && ! this.state.custom_loaded) {
            this.setState({
                articles_last_period: this.props.profile_details.reports.articles_last_period[0].media,
                articles_this_period: this.props.profile_details.reports.articles_this_period[0].media,
                num_bookings_last_period: this.props.profile_details.reports.num_bookings_last_period[0].bookings,
                num_bookings_this_period: this.props.profile_details.reports.num_bookings_this_period[0].bookings
            })
        }
        setTimeout(()=> {
            this.setState({rerenderChart: this.state.rerenderChart + 1})
        }, 500)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
        if ("reports" in nextProps.profile_details && ! this.state.custom_loaded) {
            this.setState({
                articles_last_period: nextProps.profile_details.reports.articles_last_period[0].media,
                articles_this_period: nextProps.profile_details.reports.articles_this_period[0].media,
                num_bookings_last_period: nextProps.profile_details.reports.num_bookings_last_period[0].bookings,
                num_bookings_this_period: nextProps.profile_details.reports.num_bookings_this_period[0].bookings
            })
        }
    }

    handleResize() {
        this.setState({windowWidth: window.innerWidth});
    }

    setupBookingsBreakdown(bookings_list, num_months) {
        var bookings_breakdown = [];

        //Sort the given list first so its easier to search
        var sorted_bookings = {};
        for (var i = 0; i < bookings_list.length; i++) {
            if (! (bookings_list[i].year in sorted_bookings)) {
                sorted_bookings[bookings_list[i].year] = {}
            }
            sorted_bookings[bookings_list[i].year][bookings_list[i].month] = bookings_list[i].bookings;
        }

        //Loop through bookings in list, starting from today, go back a month at a time and check if 
        var current_month = parseInt(moment().month()) + 1;
        var current_year = parseInt(moment().year());
        
        for (i = num_months; i > 0; --i) {
            if (current_year in sorted_bookings && current_month in sorted_bookings[current_year]) {
                bookings_breakdown.unshift({
                    name: moment(current_month, 'M').format('MMM'),
                    Bookings: sorted_bookings[current_year][current_month],
                    pv: sorted_bookings[current_year][current_month],
                    amt: sorted_bookings[current_year][current_month]
                })
            } else {
                bookings_breakdown.unshift({
                    name: moment(current_month, 'M').format('MMM'),
                    Bookings: 0,
                    pv: 0,
                    amt: 0
                })
            }

            current_month = current_month - 1;
            if (current_month === 0) {
                current_year = current_year - 1;
                current_month = 12;
            }
        }

        return bookings_breakdown;
    }

    reloadReports(option) {
        this.setState({
            loading: true
        })

        var self = this;
        var time = option.value

        axios.post('/ajax/profile/overlaystats/' + this.props.profile_details.profile.ID, {
            time_period: time
        })
        .then(function(response) {
            self.setState({
                bookings_breakdown: self.setupBookingsBreakdown(self.props.profile_details.booking_breakdown, time),
                articles_last_period: response?.data.reports.articles_last_period[0].media,
                articles_this_period: response?.data.reports.articles_this_period[0].media,
                num_bookings_last_period: response?.data.reports.num_bookings_last_period[0].bookings,
                num_bookings_this_period: response?.data.reports.num_bookings_this_period[0].bookings,
                custom_loaded: true,
                loading: false
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }
        })
    }

    generateActivity() {
        var activity_items = [];
    
        if (this.props.profile_details.bookings.current.length > 0) {
            for (var i = this.props.profile_details.bookings.current.length - 1; i >= 0; --i) {
                if (this.props.profile_details.bookings.current[i].Released_On !== null) {
                    activity_items.push(
                        <div className="overlay_block_activity_timeline_item" key={"current_activity_" + i}>
                            <div className="overlay_timeline_item_header">
                                <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                                    <a className="overlay_timeline_item_header_image_container" style={{marginLeft: "-15px"}}>
                                        {VCCheckout('fill-primary')}
                                    </a>
                                    <div className="overlay_timeline_item_middle" style={{marginLeft: "-5px"}}>
                                        <div className="overlay_timeline_item_header_text">
                                        {this.props.profile_details.bookings.current[i].profile.First_Name} {this.props.profile_details.bookings.current[i].profile.Last_Name} picked up a vehicle
                                        </div>
                                        <div>
                                            <span className="overlay_timeline_item_subheader_text">{this.props.profile_details.bookings.current[i].vehicle.Year} {this.props.profile_details.bookings.current[i].vehicle.Make} {this.props.profile_details.bookings.current[i].vehicle.Model}</span>
                                            <br />
                                            <span className="overlay_timeline_item_subheader_text">{moment(this.props.profile_details.bookings.current[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(this.props.profile_details.bookings.current[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="overlay_timeline_item_header_date">
                                    {moment(this.props.profile_details.bookings.current[i].Released_On).format("MMM DD")}
                                </div>
                            </div>
                        </div>
                    )
                }
            }
        }

        //Go through the past bookings and do the above, but go forward throguh them
        for (var i = this.props.profile_details.bookings.past.length - 1; i >= 0 ; --i) {
            if (this.props.profile_details.bookings.past[i].Returned_On !== null) {
                activity_items.push(
                    <div className="overlay_block_activity_timeline_item" key={"past_returned_" + i}>
                        <div className="overlay_timeline_item_header">
                            <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                                <a className="overlay_timeline_item_header_image_container" style={{marginLeft: "-22px"}}>
                                    {VCCheckin('fill-primary')}
                                </a>
                                <div className="overlay_timeline_item_middle">
                                    <div className="overlay_timeline_item_header_text">
                                    {this.props.profile_details.bookings.past[i].profile.First_Name} {this.props.profile_details.bookings.past[i].profile.Last_Name} dropped off a vehicle
                                    </div>
                                    <div>
                                    <span className="overlay_timeline_item_subheader_text">{this.props.profile_details.bookings.past[i].vehicle.Year} {this.props.profile_details.bookings.past[i].vehicle.Make} {this.props.profile_details.bookings.past[i].vehicle.Model}</span>
                                        <br />
                                        <span className="overlay_timeline_item_subheader_text">{moment(this.props.profile_details.bookings.past[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(this.props.profile_details.bookings.past[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="overlay_timeline_item_header_date">
                                {moment(this.props.profile_details.bookings.past[i].Returned_On).format("MMM DD")}
                            </div>
                        </div>
                    </div>
                )
            }

            if (this.props.profile_details.bookings.past[i].Released_On !== null) {
                activity_items.push(
                    <div className="overlay_block_activity_timeline_item" key={"past_released_" + i}>
                        <div className="overlay_timeline_item_header">
                            <div style={{display: 'flex', flex: 1, flexDirection: 'row'}}>
                                <a className="overlay_timeline_item_header_image_container" style={{marginLeft: "-15px"}}>
                                    {VCCheckout('fill-primary')}
                                </a>
                                <div className="overlay_timeline_item_middle" style={{marginLeft: "-5px"}}>
                                    <div className="overlay_timeline_item_header_text">
                                    {this.props.profile_details.bookings.past[i].profile.First_Name} {this.props.profile_details.bookings.past[i].profile.Last_Name} picked up a vehicle
                                    </div>
                                    <div>
                                    <span className="overlay_timeline_item_subheader_text">{this.props.profile_details.bookings.past[i].vehicle.Year} {this.props.profile_details.bookings.past[i].vehicle.Make} {this.props.profile_details.bookings.past[i].vehicle.Model}</span>
                                        <br />
                                        <span className="overlay_timeline_item_subheader_text">{moment(this.props.profile_details.bookings.past[i].Start_Date).format("ddd MMM DD, YYYY")} - {moment(this.props.profile_details.bookings.past[i].End_Date).format("ddd MMM DD, YYYY")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="overlay_timeline_item_header_date">
                                {moment(this.props.profile_details.bookings.past[i].Released_On).format("MMM DD")}
                            </div>
                        </div>
                    </div>
                )
            }
        }


        if (activity_items.length > 0) {
            return activity_items;
        } else {
            return <div><EmptyState image = "User_Inactive.svg" text = "No Activity"/></div>
        }
        
    }

    getLastBooking() {
        let bookings = this.props.profile_details.bookings;
        //check 'current' array
        let lastBooking = moment('Jan 1, 2000');
        if (bookings.current && bookings.current.length > 0) {
            bookings.current.map((booking) => {
                if (booking.End_Date && moment(booking.End_Date).isAfter(lastBooking)) {
                    lastBooking = booking;
                }
            });
        }
        if (bookings.past && bookings.past.length > 0) {
            if (moment(bookings.past[bookings.past.length - 1].End_Date).isAfter(lastBooking)) {
                lastBooking = bookings.past[bookings.past.length - 1];
            }
        }
        if (lastBooking.End_Date && lastBooking !== moment('Jan 1, 2000'))
            return moment(lastBooking.End_Date).format('MMM DD, YYYY').trim();
        else return 'None';
    }

    checkDifference(current, previous, type = null) {
        //Type should be percentage 
        var sign = "";

        if (current > previous) { 
            return(
                <div className="overlay_block_main_stat_numbers">
                    <div className="overlay_block_main_stat_large">
                        {current}{type === "percentage" ? "%" : null}
                    </div>
                    <div className="overlay_block_main_stat_boxed positive_boxed">
                        + {current - previous} {type === "percentage" ? "%" : null}
                    </div>
                </div>
            )
        } else if (current < previous) {
            return(
                <div className="overlay_block_main_stat_numbers">
                    <div className="overlay_block_main_stat_large">
                        {current}{type === "percentage" ? "%" : null}
                    </div>
                    <div className="overlay_block_main_stat_boxed negative_boxed">
                        - {previous - current} {type === "percentage" ? "%" : null}
                    </div>
                </div>
            )
        } else if (current === previous) {
            return(
                <div className="overlay_block_main_stat_numbers">
                    <div className="overlay_block_main_stat_large">
                        {current}{type === "percentage" ? "%" : null}
                    </div>
                </div>
            )
        }
    }

    render() {

        var keys = Object.keys(this.props.profile_details.surveys)
        var data = this.props.profile_details.surveys;

        let completed = [];
        let sent = [];

        keys.map((survey, index) => {
            if (data['' + survey].completed_date) {
                completed.push({name: survey, data: data['' + survey]});
            } else {
                sent.push({name: survey, data: data['' + survey]});
            }
        });

        return(
            <div className="row expanded bkg-white-dark">
                <div className="columns large-12 medium-12 small-12">
                    <GridContainer justifyContent='space-evenly' direction={this.state.windowWidth <= 768 ? "column" : "row"}>
                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 8}>
                            <div style={{marginTop: 8}}>
                                <div style={{display: 'flex', flex: 1, flexDirection: this.state.windowWidth <= 768 ? 'column' : 'row'}}>
                                    <ActivityCard 
                                        label="Bookings"
                                        iconName="Booking"
                                        onClick={()=> {this.props.setTab('Bookings')}}
                                        activityCards={[
                                            <ActivityCardItem headerValue={this.props.profile_details.bookings.past ? this.props.profile_details.bookings.past.length : '0' } labelValue="Total"/>, 
                                            <ActivityCardItem headerComponent={<Heading5 style={this.state.windowWidth <= 768 ? {} : {fontSize: '1vw'}}>{this.getLastBooking()?.toString()}</Heading5>} labelValue="Last Booking"/>
                                        ]}
                                    />
                                    <ActivityCard 
                                        label="Surveys"
                                        iconName="Survey"
                                        onClick={()=> {this.props.setTab('Surveys')}}
                                        activityCards={[
                                            <ActivityCardItem headerValue={"" + completed.length} labelValue="Completed"/>, 
                                            <ActivityCardItem headerValue={"" + sent.length} labelValue="Outstanding"/>
                                        ]}
                                    />
                                    <ActivityCard 
                                        label="Media"
                                        iconName="Media"
                                        onClick={()=> {
                                            this.props.media_user ?
                                                this.props.setTab('Media') : null
                                        }}
                                        activityCards={[
                                            <ActivityCardItem headerValue={"" + this.props.profile_details?.media?.complete?.length} labelValue="Completed"/>, 
                                            <ActivityCardItem headerValue={"" + this.props.profile_details?.media?.outstanding?.length} labelValue="Outstanding"/>
                                        ]}
                                    />
                                </div>
                                {/* 17% margin on each edge to keep cards the same size as the top two (50% of width - 33% of width) */}
                                {/* <div style={{display: 'flex', flex: 1, flexDirection: this.state.windowWidth <= 768 ? 'column' : 'row', marginLeft: this.state.windowWidth <= 768 ? 0 : '17%', marginRight: this.state.windowWidth <= 768 ? 0 : '17%'}}>
                                    <ActivityCard 
                                        label="Damage"
                                        iconName="Expenses"
                                        activityCards={[
                                            <ActivityCardItem headerValue="0"/> 
                                        ]}
                                    />
                                    <ActivityCard
                                        label="Expenses"
                                        iconName="Expenses"
                                        activityCards={[
                                            <ActivityCardItem headerValue="$0.00"/> 
                                        ]}
                                    />
                                </div> */}
                            </div>
                            <div style={{flex: 2, display: 'flex', flexDirection: this.state.windowWidth <= 768 ? 'column' : 'row'}}>
                                <div className="ds-card" style={{marginTop: 16, display: 'flex', flex: 1, flexDirection: 'column'}}>
                                    <div style={{borderBottom: `solid 1px ${colours.primary.grey03}`, display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', paddingBottom: 8, marginBottom: 8}}>
                                        <div>
                                            <P2><Trans>Bookings</Trans></P2>
                                            <P3 style={{marginTop: 4, color: colours.primary.grey02}}><Trans>Past 12 months</Trans></P3>
                                        </div>
                                    </div>
                                    <div style={{width: '100%', height: 200}}>
                                        <ResponsiveContainer width="99%">
                                            <AreaChart data={this.state.bookings_breakdown} dataKey="value" activeDot={{ stroke: 'red', strokeWidth: 2, r: 10 }}
                                                    margin={{top: 10, right: 0, left: 0, bottom: 0}} key={"chart_" + this.state.rerenderChart}>
                                                <defs>
                                                    <linearGradient id="colorBookings" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="0%" stopColor="#E8EFFF" stopOpacity={1}/>
                                                    </linearGradient>
                                                </defs>
                                                <CartesianGrid strokeDasharray="0"/>
                                                <XAxis dataKey="name"/>
                                                <Tooltip/>
                                                <Area type='monotone' dataKey='Bookings' stroke='#1665D8' fill='#265BFF' fill="url(#colorBookings)"/>
                                            </AreaChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                                {this.state.windowWidth <= 768 ? null : <div style={{marginLeft: 16}}></div>}
                                <div className="ds-card" style={{marginTop: 16, paddingBottom: 16, display: 'flex', flex: 1, flexDirection: 'column'}}>
                                    <div style={{borderBottom: `solid 1px ${colours.primary.grey03}`, display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', paddingBottom: 8, marginBottom: 8}}>
                                        <div>
                                            <P2><Trans>Media Submissions</Trans></P2>
                                            <P3 style={{marginTop: 4, color: colours.primary.grey02}}><Trans>All time</Trans></P3>
                                        </div>
                                    </div>
                                    <ResponsiveContainer width="99%" height={200}>
                                        <PieChart height={200} width={200}>
                                            <Pie 
                                                data={
                                                    [
                                                        {name: 'Added Media', fill: colours.primary.blue, value: this.props.profile_details.media.complete.length},
                                                        {name: 'Outstanding Media', fill: colours.accent.error_red , value: this.props.profile_details.media.outstanding.length}
                                                    ]
                                                } 
                                                dataKey="value"
                                                innerRadius={75}
                                                outerRadius={80}
                                            > 
                                            </Pie>
                                                <Legend
                                                    verticalAlign="bottom" 
                                                    wrapperStyle={{bottom: -12}} 
                                                    content={
                                                        <div style={{display: 'flex', flex: 2, flexDirection: 'row', justifyContent: 'space-around'}}>
                                                            <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', marginRight: 32}}>
                                                                <div style={{backgroundColor: colours.primary.blue, width: 4, height: 16, marginRight: 8, borderRadius: 15}}></div>
                                                                <P3 style={{color: colours.primary.grey01, marginRight: 8}}>Completed</P3>
                                                                <P2Bold>{this.props.profile_details.media.complete.length}</P2Bold>
                                                            </div>
                                                            <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                                                                <div style={{backgroundColor: colours.accent.error_red, width: 4, height: 16, marginRight: 8, borderRadius: 15}}></div>
                                                                <P3 style={{color: colours.primary.grey01, marginRight: 8}}>Outstanding</P3>
                                                                <P2Bold>{this.props.profile_details.media.outstanding.length}</P2Bold>
                                                            </div>
                                                        </div>}
                                                />
                                        </PieChart>
                                    </ResponsiveContainer>
                                    <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'center', 
                                    marginRight: this.props.profile_details.media.outstanding.length + this.props.profile_details.media.complete.length > 9 ? 52 : 38}}>
                                        <div style={{position: 'relative'}}>
                                            <div className="pie-chart-center-text" style={{height: 50}}>
                                                <Heading3>
                                                    {this.props.profile_details.media.outstanding.length + this.props.profile_details.media.complete.length}
                                                </Heading3>
                                                <P3 style={{color: colours.primary.grey02}}>Total Media</P3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </GridItem>
                        <GridItem xs={this.state.windowWidth <= 768 ? 12 : 4}>
                            <div className="ds-card">
                                <div className="block_activity">
                                    <div style={{borderBottom: `solid 1px ${colours.primary.grey03}`, paddingBottom: 8, marginBottom: 8}}>
                                        <P2><Trans>Activity</Trans></P2>
                                    </div>
                                    <div className="overlay_block_main activity_main">
                                        <div className="overlay_block_activity_timeline">
                                            {this.generateActivity()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </GridItem>
                    </GridContainer>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data
})

export default connect(mapStateToProps)(ProfileOverviewTab)